<template>
  <div id="tip_alertModal">
    <div class="t-alert-mask"></div>


    <div class="dialog_layout">
      <div class="vip_head">
      </div>
      <img class="vip_head_img" src="../../assets/vip_back2.png">

      <div class="title">开通会员享特权</div>
      <div class="sub_title">会员可随心定制，无限次代接</div>

      <div class="btn3" @click="confirm">
        <img class="vipimg" src="@/assets/ic_vip.png">
        <div class="btn3_text">开通会员</div>
      </div>

      <div class="help_layout" @click="cancel">
        <div class="help">暂不开通</div>
        <img class="help_arch" src="@/assets/arrow2.png"></img>
      </div>

    </div>
  </div>
</template>

<script>
//https://www.jb51.net/article/195339.htm
export default {
  data () {
    return {
      show: true, // 通过这个属性，控制是否移除dom元素
    }
  },
  props: {
    title: {
      type: String,
      default: 'title'
    },
    a_close: {
      type: Object,
      default: null
    },
    a_confirm: {
      type: Object,
      default: null
    },
    a_cancel: {
      type: Object,
      default: null
    }
  },
  methods: {
    close () {
      // 右上角关闭
      this.a_close && this.a_close()
      this.show = false
      // 删除判断增加的window属性
      delete window.alertIsShow
      delete window.cancelVipWindow
    },
    confirm () {
      // 确定
      this.a_confirm && this.a_confirm()
      this.show = false
      // 删除判断增加的window属性
      delete window.alertIsShow
      delete window.cancelVipWindow
    },
    cancel () {
      // 取消
      this.a_cancel && this.a_cancel()
      this.show = false
      // 删除判断增加的window属性
      delete window.alertIsShow
      delete window.cancelVipWindow
    },
  },

  mounted () {
    window.cancelVipWindow = this.cancel    // 方法赋值给window
  },
  watch: {
    show (cur, old) {
      // 通过监控data里的show属性 弹框有三个事件（右上角取消 确定按钮 取消按钮）
      // 每个事件写了 this.show = false
      // 当弹框出现的时候 点击任何一个事件 都会触发这里的监控事件 将页面上的弹框Dom移除
      if (cur === false) {
        let tip_alert = document.getElementById('tip_alertModal')
        tip_alert.parentNode.removeChild(tip_alert)
      }
    }
  }
}
</script>
<style scoped>
#tip_alertModal {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
}


.t-alert-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .3);
}

.dialog_layout {
  position: absolute;
  width: 19rem;
  height: 20.44rem;
  background: #FFFFFF;
  box-shadow: 0 0.25rem 1.25rem 0 rgba(0, 0, 0, 0.05);
  border-radius: 0.8rem;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  left: 50%;


  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
}

.vip_head {
  width: 100%;
  height: 8.815rem;
  background: linear-gradient(136deg, #FFF3C8 0%, #FFC071 100%);
  border-radius: 0.8rem 0.8rem 0 0;
  opacity: 0.2;
}

.vip_head_img {
  position: relative;
  width: 14.1rem;
  height: 7.25rem;
  margin-top: -7.25rem;
  /*opacity: 0.2;*/
}

.title {
  font-family: PingFangSC-Medium;
  font-size: 1.2rem;
  color: #7F4108;
  text-align: center;
  margin-top: 1rem;
}

.sub_title {
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: #000000;
  text-align: center;
  margin-top: 1rem;
}

.btn3 {
  position: relative;
  width: 88%;
  height: 2.815rem;
  border-radius: 0.2rem;
  box-sizing: border-box;
  background: #34384a;

  text-align: center;
  box-sizing: border-box;
  margin-top: 1rem;

  display: flex;
  flex-direction: row;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.btn3_text {
  line-height: 2.815rem;
  font-size: 1rem;
  color: #FFFFFF;
  border: 1px solid transparent;
  box-sizing: border-box;
}

.vipimg {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
}


.help_layout {
  display: flex;
  flex-direction: row;
  margin-top: 0.8rem;
  align-content: center;
  align-items: center;
  height: 1.2rem;
}


.help {
  height: 1.2rem;
  font-family: PingFangSC-Regular;
  font-size: 0.9rem;
  line-height: 1.25rem;
  color: #999999;
  letter-spacing: 0;
  text-align: center;
}

.help_arch {
  width: 0.8rem;
  height: 0.8rem;
  margin-left: 0.5rem;
  margin-bottom: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/VipAlert.vue